import * as Sentry from "@sentry/react";

const dsn = process.env.REACT_APP_SENTRY_DSN?.trim();

if (dsn) {
  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || "production",
    sampleRate: 1.0,
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || "0.10"),
    beforeSend(event) {
      const scrub = (value) => {
        if (!value || typeof value !== "object") return value;
        if (Array.isArray(value)) return value.map(scrub);
        return Object.fromEntries(
          Object.entries(value).map(([key, item]) =>
            /(authorization|cookie|password|secret|token|api[-_]?key|card|cvv|cvc|payment|stripe)/i.test(key)
              ? [key, "[Filtered]"]
              : [key, scrub(item)]
          )
        );
      };
      for (const field of ["request", "extra", "contexts", "user", "tags", "breadcrumbs"]) {
        if (event[field]) event[field] = scrub(event[field]);
      }
      return event;
    },
  });
}
